import { Menu, MenuItem, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useRecoilState } from "recoil";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LoadingButton } from "@mui/lab";
import { authState } from "src/store/auth";
import ActivateDriverPopup from "../../activate-driver-popup";

const TableActions = ({
  rowId,
  refetch,
}: {
  rowId: string;
  refetch: () => void;
}) => {
  const navigate = useNavigate();
  const [auth] = useRecoilState(authState);
  const { permissions } = auth;
  const [openPopup, setOpenPopup] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleNavigateToEditPage = () => {
    navigate(`/delivery/archived/${rowId}`);
  };

  return (
    <Stack direction={"row"}>
      {permissions?.delivery.edit ? (
        <LoadingButton
          variant="contained"
          color="inherit"
          endIcon={<KeyboardArrowDownIcon />}
          onClick={handleClick}
          size="small"
          sx={{ fontSize: "12px", color: "#7E8299", fontWeight: 600 }}
        >
          Actions
        </LoadingButton>
      ) : null}

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={handleNavigateToEditPage}
          sx={{ width: "105px", color: "primary.main" }}
        >
          Edit
        </MenuItem>
        <MenuItem onClick={handleOpenPopup}>Activate</MenuItem>
      </Menu>

      {openPopup && (
        <ActivateDriverPopup
          open={openPopup}
          onClose={handleClosePopup}
          refetch={refetch}
          id={rowId}
        />
      )}
    </Stack>
  );
};
export default TableActions;
